const createRandomUUID = (cryptoApi) => () => {
  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  let hex = '';
  for (let index = 0; index < bytes.length; index += 1) {
    hex += bytes[index].toString(16).padStart(2, '0');
  }

  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-');
};

const defineRandomUUID = (target, randomUUID) => {
  try {
    Object.defineProperty(target, 'randomUUID', {
      configurable: true,
      value: randomUUID,
    });
  } catch (error) {
    try {
      target.randomUUID = randomUUID;
    } catch (assignmentError) {
      return false;
    }
  }

  return typeof target.randomUUID === 'function';
};

export function installCryptoRandomUUID(cryptoApi) {
  if (
    !cryptoApi
    || typeof cryptoApi.randomUUID === 'function'
    || typeof cryptoApi.getRandomValues !== 'function'
  ) {
    return false;
  }

  const randomUUID = createRandomUUID(cryptoApi);
  if (defineRandomUUID(cryptoApi, randomUUID)) return true;

  const prototype = Object.getPrototypeOf(cryptoApi);
  if (
    prototype
    && prototype !== cryptoApi
    && typeof prototype.randomUUID !== 'function'
    && defineRandomUUID(prototype, randomUUID)
  ) {
    return true;
  }

  return false;
}

if (typeof window !== 'undefined') {
  installCryptoRandomUUID(window.crypto);
}
